import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import Application from './InternalPages/Application';
import Congratulations from './InternalPages/Congratulations';
import CreditAppDecision from './InternalPages/CreditAppDecision';
import AutoPayElection from './InternalPages/AutoPayElection';
import CreditOfferConfirmation from './InternalPages/CreditOfferConfirmation';
import CreditAppDoc from './InternalPages/CreditAppDoc';
import WorkflowComplete from './InternalPages/WorkflowComplete';
import SignLoanDocument from './InternalPages/SignLoanDocument';

const routes = [
  {
    name: 'Application',
    pathname: '/dashboard/borrowers-merchant/application',
    component: Application,
    exact: true,
  },
  {
    name: 'Congratulations',
    pathname: '/dashboard/borrowers-merchant/congratulations',
    component: Congratulations,
    exact: true,
  },
  {
    name: 'Credit Offer',
    pathname: '/dashboard/borrowers-merchant/creditoffer',
    component: CreditAppDecision,
    exact: true,
  },
  {
    name: 'Auto-Pay Election',
    pathname: '/dashboard/borrowers-merchant/autopayelection',
    component: AutoPayElection,
    exact: true,
  },
  {
    name: 'Credit Offer Confirmation',
    pathname: '/dashboard/borrowers-merchant/creditofferconfirmation',
    component: CreditOfferConfirmation,
    exact: true,
  },
  {
    name: 'Credit App Docusign',
    pathname: '/dashboard/borrowers-merchant/creditappdoc',
    component: CreditAppDoc,
    exact: true,
  },
  {
    name: 'Workflow Complete',
    pathname: '/dashboard/borrowers-merchant/complete',
    component: WorkflowComplete,
    exact: true,
  },
  {
    name: 'Sign Loan Document',
    pathname: '/dashboard/borrowers-merchant/signloandocument',
    component: SignLoanDocument,
    exact: true,
  },
];

const BorrowerApply = () => (
  <Switch>
    {routes.map((route, index) => (
      <Route
        key={index}
        path={route.pathname}
        exact={route.exact || false}
        render={routerProps => (
          <route.component {...routerProps} />
        )}
      />
    ))}
    <Redirect to="/dashboard" />
  </Switch>
);

export default BorrowerApply;



// WEBPACK FOOTER //
// ./src/containers/pages/BorrowerMerchantApply/index.js